import { Component, OnInit, Input } from '@angular/core';
import { OrderItem } from 'src/app/class/OrderItem';
import { RetailStoreData } from 'src/app/class/RetailStoreData';
import { SubService } from 'src/app/service/sub.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {
  @Input()
  list: Array<OrderItem>;

  @Input()
  item: OrderItem;

  @Input()
  qtyField: string;

  @Input()
  display: string;

  @Input()
  subbedList: Array<OrderItem>;

  @Input()
  subbedItem: OrderItem;

  isOutOfStock = false;
  isSub = false;
  isPriceDeltaEnabled = false;

  constructor(private subService: SubService) {}

  ngOnInit() {
    this.subService.getRetailStore().subscribe({
      next: (retailStore: RetailStoreData) => {
        this.isPriceDeltaEnabled = retailStore.isPriceDeltaEnabled;
      }
    });

    if (this.item) {
      this.list = new Array(this.item);
    }

    if (this.subbedItem) {
      this.subbedList = new Array(this.subbedItem);
    }

    if (this.display === 'oos') {
      this.isOutOfStock = true;
    } else if (this.display === 'sub') {
      this.isSub = true;
    }
  }
}
